<!-- main.vue -->
<template>
  <div class="toast">
    <p>{{ content }}</p>
  </div>
</template>
  <script>
export default {
  name: "Toast",
  data() {
    return {
      content: "",
      duration: 2000,
    };
  },
  mounted() {
    setTimeout(() => {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    }, this.duration);
  },
};
</script>
  <style lang="scss" scoped>
.toast {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: #FFF;
  z-index: 9999;
  background: transparent;
  > p {
    padding: 6px 11px;
    font-size: 12px;
    border-radius: 4px;
    background: #333;
  }
}
</style>